export const themeColors = {
  primary: '#41b883',
  primaryMedium: '#b4e4ce',
  primaryLight: '#f7fcfa',
  secondary: '#ff227d',
  accent: '#797bf2',
  accentMedium: '#d4b3ff',
  accentLight: '#b8ccff',
  success: '#06d6a0',
  info: '#039BE5',
  warning: '#faae42',
  danger: '#FF7273',
  purple: '#8269B2',
  blue: '#37C3FF',
  green: '#93E088',
  yellow: '#FFD66E',
  orange: '#FFA981',
  lightText: '#a2a5b9',
  fadeGrey: '#ededed',
}
